import ReactDOM from 'react-dom/client';
import { UserProvider, useUser } from './hooks/useUser';
import { AuthResponse, AuthUser, Dashboard, Project } from '@/screens';
import { createBrowserRouter, Navigate, Outlet, RouterProvider } from 'react-router-dom';
import { Toast } from 'react-frontier';

import 'semantic-ui-css/semantic.min.css'
import 'frontier-css/css/frontier.css';

var PrivateGuard=()=>{
   var {user}=useUser();
   if(!user)return <Navigate to={'/'} replace />
   return <Outlet />
}

var Router=createBrowserRouter([
   {
      path: '/',
      element: <AuthUser />
   },
   {
      path: '/auth',
      element: <AuthResponse />
   },
   {
      element: <PrivateGuard />,
      children: [
         { path: '/dashboard', element: <Dashboard /> },
         { path: '/project/:project_id', element: <Project /> }
      ]
   }
])

var Root=()=>{
   return (
      <Toast.Provider>
         <UserProvider>
            <RouterProvider router={Router} />
         </UserProvider>
      </Toast.Provider>
   );
};

const root = ReactDOM.createRoot(
   document.getElementById('root') as HTMLElement
);

root.render(<Root />);
